module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "db"
  }, [(!_vm.$route.meta.hidden) ? [_c('header', {
    staticClass: "db-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        path: '/list/filters'
      }
    }
  }, [_vm._v("Element Dashboard")]), _vm._v(" "), (_vm.user.id) ? _c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.user.username)
    }
  }), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("个人信息")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("设置")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_vm._v("注销")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "db-body"
  }, [_c('aside', {
    staticClass: "db-menu-wrapper"
  }, [_c('el-menu', {
    staticClass: "db-menu-bar",
    attrs: {
      "default-active": _vm.activeMenu,
      "router": ""
    }
  }, [_vm._l((_vm.$router.options.routes[_vm.$router.options.routes.length - 2].children), function(route, index) {
    return [(route.children && route.name) ? [_c('el-submenu', {
      attrs: {
        "index": route.name
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: route.iconClass
    }), _vm._v(_vm._s(route.name))]), _vm._v(" "), _vm._l((route.children), function(cRoute, cIndex) {
      return _c('el-menu-item', {
        attrs: {
          "index": cRoute.name,
          "route": cRoute
        }
      }, [_vm._v(_vm._s(cRoute.name))])
    })], 2)] : _vm._e(), _vm._v(" "), (!route.children && route.name) ? [_c('el-menu-item', {
      attrs: {
        "index": route.name,
        "route": route
      }
    }, [_c('i', {
      class: route.iconClass
    }), _vm._v(_vm._s(route.name))])] : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "db-content-wrapper"
  }, [_c('section', {
    staticClass: "db-content"
  }, [_c('router-view')], 1)])])] : [_c('router-view')]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e650c868!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 563
// module chunks = 2